export default "<br><br>\n<div [ngStyle]=\"{'background-color': color}\" class=\"title-div\">\n  <h2 class=\"title\">{{titleText}}</h2>\n</div>\n<br><br>"